/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
const options = {
	billing: [
		{
			db_key: 'monthly',
			display: 'Monthly'
		},
		{
			db_key: 'annual',
			display: 'Annually'
		}
	],
	renewal: [
		{
			db_key: 'one-time',
			display: 'One Time'
		},
		{
			db_key: 'auto',
			display: 'Automatic'
		}
	]
};

export default options;
